export const CONFIG_LOADED = "@ee/CONFIG_LOADED";
export const HTTP_DISPATCH = "@ee/HTTP_DISPATCH";
export const HTTP_BUSY = "@ee/HTTP_BUSY";
export const HTTP_SUCCESS = "@ee/HTTP_SUCCESS";
export const HTTP_FAILURE = "@ee/HTTP_FAILURE";
export const LANGUAGE_LOADED = "@ee/LANGUAGE_LOADED";

export const configLoaded = config => {
  return {
    type: CONFIG_LOADED,
    config
  };
};

export const http = (
  method,
  url,
  payload = {},
  body,
  message = null,
  cb = null
) => {
  return {
    type: HTTP_DISPATCH,
    method,
    url,
    payload,
    body,
    message,
    cb
  };
};

export const post = (url, payload, message, cb) => {
  return http("POST", url, payload, null, message, cb);
};
export const get = url => {
  return http("GET", url);
};
export const put = (url, payload) => {
  return http("PUT", url, payload);
};
export const del = url => {
  return http("DELETE", url);
};

export const postPhoto64 = (url, photo, message, cb) => {
  const payload = { photoBase64: photo, photoExt: "jpg" };
  return http(
    "POST",
    url.replace("photo/", "photobase64/"),
    payload,
    null,
    message,
    cb
  );
};

export const postFile = (url, name, payload, message, cb) => {
  var formData = new FormData();
  formData.append(name, payload);

  return http("POST", url, null, formData, message, cb);
};

export const registerMember = (properties, message, cb) => {
  return post("/registermember", { properties }, message, cb);
};

export const registerTicket = (ticketIdentitfier, properties, message, cb) => {
  return post(
    "/registerticket",
    { ticketIdentitfier, properties },
    message,
    cb
  );
};

export const setPassword = (customerId, newPassword, cb) => {
  return post("/setpassword", { customerId, newPassword }, null, cb);
};

export const changePassword = (customerId, oldPassword, newPassword) => {
  return post("/changepassword", { customerId, oldPassword, newPassword });
};

export const requestPassword = (email, cb) => {
  return post(`/requestpassword?email=${email}`, {}, null, cb);
};

export const uploadPhoto64 = (url, photo, message, cb) => {
  return postPhoto64(url, photo, message, cb);
};

export const setCookie = (key, value) => {
  return {
    type: "@EE/SET_COOKIE",
    key,
    value
  };
};

export const expireCookie = key => {
  return {
    type: "@EE/EXPIRE_COOKIE",
    key
  };
};
